/**
 * sennagrey.com — entry point.
 *
 * Wires up the four feature modules. Each module is independently
 * importable and unit-testable; this file just orchestrates the
 * DOMContentLoaded sequence.
 *
 * Module responsibilities:
 *   - age-gate.js       18+ modal, persistent per session
 *   - reveal.js         IntersectionObserver scroll-reveal
 *   - nav.js            Active section highlighting + copyright year
 *   - newsletter.js     Provider-agnostic signup form
 *   - books.js          Renders the catalog into the #books grid
 *   - hero.js           Renders the hero name + dek/tagline from data
 */

import { initAgeGate } from './src/age-gate.js';
import { setupScrollReveal } from './src/reveal.js';
import { setupActiveNav, setCurrentYear } from './src/nav.js';
import { setupNewsletter } from './src/newsletter.js';
import { renderBooks, renderSeriesLink } from './src/books.js';
import { renderHero } from './src/hero.js';

function ready(fn) {
  if (document.readyState !== 'loading') fn();
  else document.addEventListener('DOMContentLoaded', fn);
}

ready(() => {
  // Render dynamic content first so .reveal elements exist when the
  // observer scans the DOM.
  renderHero();
  renderBooks();
  renderSeriesLink();

  const reopenAgeGate = initAgeGate({ defaultRemember: true });
  // Footer link: "Click here if you need to re-confirm."
  document.querySelectorAll('[data-age-reset]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      reopenAgeGate();
    });
  });
  setCurrentYear();
  setupScrollReveal();
  setupActiveNav();
  setupNewsletter();
});
